import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "dictation" }
const _hoisted_2 = {
  key: 0,
  class: "wave",
  "aria-hidden": "true"
}
const _hoisted_3 = {
  key: 1,
  class: "voice-status",
  role: "status"
}
const _hoisted_4 = {
  key: 2,
  class: "elapsed",
  "aria-live": "off"
}
const _hoisted_5 = ["aria-label"]
const _hoisted_6 = {
  key: 4,
  class: "spinner",
  "aria-hidden": "true"
}
const _hoisted_7 = {
  key: 2,
  role: "alert",
  class: "voice-error"
}
const _hoisted_8 = {
  class: "sr-only",
  role: "status"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.state==='idle')
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          type: "button",
          class: "mic",
          "aria-label": "Record a voice message",
          title: "Dictate a message",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.start && _ctx.start(...args)))
        }, [...(_cache[3] || (_cache[3] = [
          _createElementVNode("svg", {
            viewBox: "0 0 24 24",
            "aria-hidden": "true"
          }, [
            _createElementVNode("rect", {
              x: "9",
              y: "2",
              width: "6",
              height: "12",
              rx: "3"
            }),
            _createElementVNode("path", { d: "M5 10v2a7 7 0 0014 0v-2M12 19v3M8 22h8" })
          ], -1)
        ]))]))
      : (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: _normalizeClass(["voice-pill", {'is-recording':_ctx.state==='recording'}]),
          role: "group",
          "aria-label": "Voice recording controls"
        }, [
          _createElementVNode("button", {
            type: "button",
            "aria-label": "Cancel recording",
            title: "Discard recording",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.cancel && _ctx.cancel(...args)))
          }, "✕"),
          (_ctx.state==='recording')
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.bars, (bar, i) => {
                  return (_openBlock(), _createElementBlock("i", {
                    key: i,
                    style: _normalizeStyle({height:bar+'px'})
                  }, null, 4))
                }), 128))
              ]))
            : (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.state==='permission'?'Allow microphone…':_ctx.state==='transcribing'?'Transcribing…':'Recording ready'), 1)),
          (_ctx.state==='recording')
            ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.elapsed) + "s", 1))
            : _createCommentVNode("", true),
          (_ctx.state==='recording'||_ctx.state==='retry')
            ? (_openBlock(), _createElementBlock("button", {
                key: 3,
                type: "button",
                class: "accept",
                "aria-label": _ctx.state==='retry'?'Retry transcription':'Finish and transcribe',
                title: "Transcribe into message",
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.accept && _ctx.accept(...args)))
              }, "✓", 8, _hoisted_5))
            : (_openBlock(), _createElementBlock("span", _hoisted_6))
        ], 2)),
    (_ctx.error)
      ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(_ctx.error), 1))
      : _createCommentVNode("", true),
    _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.state==='recording'?'Microphone recording. Cancel on the left or finish on the right.':''), 1)
  ]))
}